import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import Typography from 'new/elements/Typography';
import { ReactComponent as RefreshIcon } from 'src/new/components/icons/refresh.svg';
import classes from './CredentialsHeader.module.scss';

interface CredentialsHeaderProps {
  onRefreshClicked?: () => void;
  isLoadingData?: boolean;
}

const CredentialsHeader = ({ onRefreshClicked, isLoadingData = false }: CredentialsHeaderProps) => {
  return (
    <div className={classes.credentialsHeader}>
      <Typography variant="overline">Add or Select a Credential</Typography>
      {onRefreshClicked && (
        <Button
          className={classes.refreshButton}
          variant="outlined"
          color="info"
          onClick={onRefreshClicked}
          disabled={isLoadingData}
        >
          {isLoadingData ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <>
              <RefreshIcon className={classes.refreshIcon} />
              Refresh
            </>
          )}
        </Button>
      )}
    </div>
  );
};

export default CredentialsHeader;
